import nameof from "ts-nameof.macro";
import { ObjectField, ObjectList } from "react3l-decorators";
import { ResponsibilityAppUserGroupingMappings } from "./ResponsibilityAppUserGroupingMappings";
import { AppUserGrouping } from "models/AppUserGrouping";

ObjectField(AppUserGrouping)(
  ResponsibilityAppUserGroupingMappings.prototype,
  nameof(ResponsibilityAppUserGroupingMappings.prototype.appUserGrouping)
);

ObjectList(AppUserGrouping)(
  ResponsibilityAppUserGroupingMappings.prototype,
  nameof(ResponsibilityAppUserGroupingMappings.prototype.organizations)
);

ObjectList(AppUserGrouping)(
  ResponsibilityAppUserGroupingMappings.prototype,
  nameof(ResponsibilityAppUserGroupingMappings.prototype.provinces)
);

export * from "./ResponsibilityAppUserGroupingMappings";
export * from "./ResponsibilityAppUserGroupingMappingsFilter";
